import { Component, Input, Output, OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Address, Agent, PaymentDataResponse, PaymentFormData } from './../../models';
import { BillingInformation } from '../../models/billing-information.model';
import { PaymentService } from '../../services/payment.service';

@Component({
    selector: 'agents-payment-iframe',
    template: require('./payment-iframe.component.html')
})
export class PaymentIFrameComponent implements OnInit, OnDestroy {
    @Input() paymentFormData: PaymentFormData;
    @Output() onPaymentRespond: EventEmitter<PaymentFormData> = new EventEmitter<PaymentFormData>();

    public errors: string[] = null;
    public iframeSrc: SafeUrl = 'about:blank';

    private iframeListener: EventListener;
    private cardType: string;
    private lastFour: string;
    private expiration: string;

    constructor(private sanitizer: DomSanitizer, private paymentService: PaymentService) { }

    public ngOnInit(): void {
        this.initialize();

        // only setup response listener once, if done more than once, it will trigger more than once on form submit
        this.setupResponseListener();
    }

    public ngOnDestroy(): void {
        window.removeEventListener('message', this.iframeListener, false);
    }

    public reloadForm(): void {
        if (this.showBillingInfo()) {
            this.paymentFormData.billing.paymentToken = null;
        }

        this.reloadIFrame();
    }

    public reloadIFrame(): void {
        this.errors = null;
        this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl('about:blank');
        this.initialize();
    }

    public initialize(): void {
        this.fillDisplayData(this.paymentFormData.billing);

        // sets the payment URL for the iframe
        this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(this.paymentService.getIframeUrl(this.paymentFormData));
    }

    public showErrors(): boolean {
        return this.errors !== null && this.errors !== undefined;
    }

    public showBillingInfo(): boolean {
        return Boolean(this.paymentFormData.billing
            && this.paymentFormData.billing.paymentToken !== null
            && this.paymentFormData.billing.paymentToken !== undefined);
    }

    public showPaymentIframe(): boolean {
        return (this.showErrors() === false && this.showBillingInfo() === false);
    }

    public submitPayment(billing: BillingInformation = null): void {
        if (this.onPaymentRespond) {
            if (billing) {
                this.paymentFormData.billing = billing;
            }

            this.onPaymentRespond.emit(this.paymentFormData);
        }
    }

    public windowListener(event): void {
        if (event.data) {
            let key: string = event.message ? 'message' : 'data';
            let data: PaymentDataResponse = event[key];
            if (data) {
                if (data.customerId === 'ERROR') {
                    this.handlePaymentError();
                }
                else if (data.card) {
                    let billing: BillingInformation = {
                        email: data.email,
                        paymentToken: data.cardToken,
                        address1: data.card.addressLine1,
                        address2: null,
                        city: data.card.addressCity,
                        stateOrProvince: data.card.addressState,
                        postalCode: data.card.addressZip,
                        name: data.card.name,
                        expMonth: data.card.expMonth,
                        expYear: data.card.expYear,
                        last4: data.card.last4,
                        cardType: data.card.type,
                        customerId: data.customerId
                    };

                    this.fillDisplayData(billing);

                    // calls back to parent controller to continue
                    this.submitPayment(billing);
                }
            }
        }
    }

    private handlePaymentError(): void {
        this.errors = [];
        this.errors.push('We’re sorry, but we’ve encountered a problem while submitting billing information for this trip. Please try again.');
    }

    private setupResponseListener(): void {
        this.iframeListener = (e: MessageEvent) => {
            if (this.paymentService.baseUrl.indexOf(e.origin) > -1) {
                this.windowListener(e);
            }
        };

        window.addEventListener('message', this.iframeListener, false);
    }

    private fillDisplayData(billing: BillingInformation): void {
        if (billing) {
            this.cardType = billing.cardType;
            this.lastFour = billing.last4;
            this.expiration = billing.expMonth + '/' + billing.expYear;
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/components/payment/payment-iframe.component.ts